import ScrollToSticky from '~components/ZipCodeForm/ScrollToSticky';

const TopOfArticleZipContainer = () => {
    return (
        <div className="pb-4 lg:pb-10">
            <ScrollToSticky />
        </div>
    );
};

export default TopOfArticleZipContainer;
